<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Formulario de creación</h2>
    </div>

    <div class="container-action">
        
    </div>

    <div class="container-body">
        <label for="firstname">Nombre</label>
        <input id="firstname" v-model="user.firstname" type="text" :maxlength="textInputMaxLength"
        name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

        <label for="lastname">Apellidos</label>
        <input id="lastname" v-model="user.lastname" type="text" :maxlength="textInputMaxLength"
        name="apellidos" :class="{'error' : errors.has('apellidos') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('apellidos') ? errors.first('apellidos') : 'Ingresa los apellidos']]"/>

        <label for="group">Grupos del usuario</label>
        <br>
        <div id="group" v-if="groups" :class="{'error': validationMessage && user.id_groups.length === 0}">
            <div class="group-chips" v-if="user.id_groups.length">
                <span class="group-chip" v-for="idGroup in user.id_groups" v-bind:key="idGroup">
                    {{groupNameById(idGroup)}}
                    <button type="button" class="group-chip-remove" v-on:click="removeGroup(idGroup)">×</button>
                </span>
            </div>
            <select v-model="groupToAdd" v-on:change="addGroup()">
                <option value="" disabled selected>Selecciona un grupo</option>
                <option
                v-for="item in availableGroups"
                v-bind:key="item.index"
                v-bind:value="item.id">
                {{item.name}}
                </option>
            </select>
        </div>
        <span v-else>No hay grupos que seleccionar para el usuario</span>
        <br>

        <label for="username">Correo electrónico</label>
        <input id="username" v-model="user.username" type="text" :maxlength="textInputMaxLength"
        name="nombre de usuario" :class="{'error' : errors.has('nombre de usuario') }" v-validate="'required|email|max:' + textInputMaxLength + '|unique'"
        :placeholder="[[errors.has('nombre de usuario') ? errors.first('nombre de usuario') : 'Escribe el nombre de usuario']]"/>

        <label for="login">Login (opcional)</label>
        <input id="login" v-model="user.login" type="text"
        name="login" :class="{'error' : errors.has('login') }" v-validate="'min:3|unique_login'"
        :placeholder="[[errors.has('login') ? errors.first('login') : 'Mínimo 3 caracteres']]"/>
        <p class="field-note">Se respetan exactamente las mayúsculas y minúsculas ingresadas.</p>
        
        <p class="password-note">
            La contraseña la genera el sistema y se envía al correo indicado arriba.
            Al ingresar por primera vez, el usuario deberá cambiarla por una propia.
        </p>

        <label for="region">Región</label>
        <select id="region" v-model="user.region" name="región"
        :class="{'error' : errors.has('región') }" v-validate="'required'">
            <option value="">Selecciona una región</option>
            <option v-for="item in regiones" v-bind:key="item" v-bind:value="item">{{item}}</option>
        </select>

        <label for="genero">Género</label>
        <select id="genero" v-model="user.genero" name="género"
        :class="{'error' : errors.has('género') }" v-validate="'required'">
            <option value="">Selecciona un género</option>
            <option v-for="item in generos" v-bind:key="item" v-bind:value="item">{{item}}</option>
        </select>

        <label for="cargo">Cargo</label>
        <input id="cargo" v-model="user.cargo" type="text" name="cargo" :maxlength="textInputMaxLength"
        :class="{'error' : errors.has('cargo') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('cargo') ? errors.first('cargo') : 'Ingresa el cargo']]"/>

        <label for="telefono">Teléfono (opcional)</label>
        <input id="telefono" v-model="user.telefono" type="text" name="telefono" :maxlength="textInputMaxLength"
        :class="{'error' : errors.has('telefono') }" v-validate="'max:' + textInputMaxLength"
        :placeholder="[[errors.has('telefono') ? errors.first('telefono') : 'Ingresa el teléfono']]"/>

        <label for="es_externo">Tipo de usuario</label>
        <div id="es_externo">
            <input type="checkbox" id="checkbox-es-externo" v-model="user.es_externo" v-on:change="syncInstitutionWithUserType()">
            <label for="checkbox-es-externo">Usuario externo</label>
        </div>

        <template v-if="user.es_externo">
            <label for="institucion">Institución</label>
            <input id="institucion" v-model="user.institucion" type="text" :maxlength="textInputMaxLength"
            name="institución" :class="{'error' : errors.has('institución') }" v-validate="'required|max:' + textInputMaxLength"
            :placeholder="[[errors.has('institución') ? errors.first('institución') : 'Ingresa la institución']]"/>
        </template>

        <label for="permissions">Permisos de usuario</label>
            <!--Cambio de nombres de permisos segun observacion SENAPRED 06/2026 ("1. En los "Permisos de Usuarios" no queda claro lo que se está habilitando (Administración o Uso).")-->
            <!--Se elimina Gestion de geoprocesos porque ya no esta habilitada la vista asociada-->
        <div id="permissions">
            <input type="checkbox" id="checkbox-visor" v-model="user.permissions.visor">
            <label for="checkbox-visor">Acceso al visor</label>
            <br>
            <input type="checkbox" id="checkbox-usuarios" v-model="user.permissions.users">
            <label for="checkbox-usuarios">Administración de usuarios</label>
            <br>
            <input type="checkbox" id="checkbox-capas" v-model="user.permissions.layers">
            <label for="checkbox-capas">Administración de capas</label>
            <br>
            <input type="checkbox" id="checkbox-mapas" v-model="user.permissions.maps">
            <label for="checkbox-mapas">Administración de mapas</label>
            <br>
            <input type="checkbox" id="checkbox-documentos" v-model="user.permissions.documents">
            <label for="checkbox-documentos">Administración de documentos</label>
            <br>
            <input type="checkbox" id="checkbox-instructivos" v-model="user.permissions.wiki">
            <label for="checkbox-instructivos">Administración de instructivos</label>
            <br>
            <input type="checkbox" id="checkbox-monitoreo" v-model="user.permissions.monitoring">
            <label for="checkbox-monitoreo">Administración de monitoreo</label>
            <br>
            <input type="checkbox" id="checkbox-terreno-gestion" v-model="user.permissions.terrain.manage">
            <label for="checkbox-terreno-gestion">Gestión de terreno</label>
            <br>
            <input type="checkbox" id="checkbox-terreno-respuesta" v-model="user.permissions.terrain.respond">
            <label for="checkbox-terreno-respuesta">Respuesta de terreno</label>
            <br>
            <input type="checkbox" id="checkbox-terreno-revision" v-model="user.permissions.terrain.review">
            <label for="checkbox-terreno-revision">Revisión de terreno</label>
            <br>
            <input type="checkbox" id="checkbox-terreno-publicacion" v-model="user.permissions.terrain.publish">
            <label for="checkbox-terreno-publicacion">Publicación de terreno</label>
        </div>

        <div class="container-action-left" style="justify-content: start;">
            <button class="btn btn-secondary" v-on:click="onClickGoBack()" :disabled="submitting">Volver</button>
            <button class="btn btn-secondary" v-on:click="onClickGoNext()" :disabled="submitting">
                {{ submitting ? 'Creando usuario y enviando correo...' : 'Registrar usuario' }}
            </button>
        </div>
    <!--mensaje de error-->
            <p class="error-label" v-if="message">{{message}}</p>
            <div v-if="errors.any() || validationMessage" class="validation-summary">
                <div v-if="validationMessage" class="validation-summary__message"
                >
                    {{ validationMessage }}
                </div>

                <div
                    v-for="error in errors.items" :key="error.id" class="validation-summary__error"
                >
                    {{ error.msg }}
                </div>
            </div>
    </div>

    <div class="container-list"> 
        
    </div>
 
</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import {restUser} from '@/components/mixin/restUser.js'
import {restGroup} from '@/components/mixin/restGroup.js'

export default{
    name: 'test',
    mixins: [restUser, restGroup],
    data(){
        return{
            validationMessage: '',
            groupToAdd: '',
            textInputMaxLength: 30,
            message: null,
            submitting: false
        }
    },
    components:{
        Breadcrumb
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: 'Crear usuario'}
              ]
        },
        availableGroups: function(){
            return this.groups.filter((item) => !this.user.id_groups.includes(item.id))
        },
    },
    props: [],
    methods:{
        onClickGoBack: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/capas/')
        },
        groupNameById: function(idGroup) {
            const group = this.groups.find((item) => item.id === idGroup)
            return group ? group.name : 'Grupo desconocido'
        },
        addGroup: function() {
            if (this.groupToAdd) {
                this.user.id_groups.push(this.groupToAdd)
                this.groupToAdd = ''
            }
        },
        removeGroup: function(idGroup) {
            this.user.id_groups = this.user.id_groups.filter((item) => item !== idGroup)
        },
        onClickGoNext: function() {

            if (this.user.id_groups.length === 0) {
                this.validationMessage = 'Selecciona al menos un grupo para el usuario.';
                return;
            }

            const that = this;
            this.$validator.validateAll()
                .then((response) => {
                if(response) {
                    this.validationMessage= '';
                    // El alta espera a que salga el correo con la contraseña temporal
                    // (QA-13), así que puede tardar varios segundos: sin este estado
                    // el formulario parece congelado.
                    that.submitting = true;
                    that.postUser().then(function () {
                        that.submitting = false;
                    }).catch(function () {
                        that.submitting = false;
                    });
                } else {
                        //actualizado manejo de error (mostrar mensaje a usuario) segun observacion SENAPRED 06/2026
                        //("3. Al  crear un usuario con un correo existente, no se crea pero, no arroja ningún mensaje que indique el por qué.")
                        this.validationMessage = 'Hay errores en el formulario. Revise los campos marcados.';
                }
            })
                .catch(error =>{
                    this.validationMessage = 'Ocurrió un error inesperado';
                    console.error(error);
                });
        },
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getGroupsNoPages();

        //Verificar username único en servidor
        const isUnique = (value) => {
            return this.$http.post(this.$store.getters.backendurl  + 'api/v1/accounts/check', {username: value})
            .then(function (response) {
                //Obtener ID de la tarea recién creada y pasar a la vista de asignar usuarios
                return {
                    valid: response.data.valid,
                    data: {
                        message: response.data.message
                    }
                };
            })
            .catch(function (error) {
                console.log(error);
                return {
                    valid: false,
                    data: {
                        message: "No se puede verificar"
                    }
                }
            });
        };
        this.$validator.extend('unique', {
            validate: isUnique,
            getMessage: (field, params, data) => {
                return data.message;
            }
        });

        const isLoginUnique = (value) => {
            return this.$http.post(this.$store.getters.backendurl + 'api/v1/accounts/check-login', {login: value})
            .then((response) => ({
                valid: response.data.valid,
                data: { message: response.data.message }
            }))
            .catch((error) => {
                console.log(error);
                return { valid: false, data: { message: 'No se puede verificar el login' } };
            });
        };
        this.$validator.extend('unique_login', {
            validate: isLoginUnique,
            getMessage: (field, params, data) => data.message
        });
    },
    watch:{
        'user.permissions.maps': function(value){
            if (value) this.user.permissions.annotation=true
            else this.user.permissions.annotation=false
        }
    }
}
</script>

<style lang="scss" scoped>
// El .error-label global es position:absolute y se encima con lo que sigue;
// acá se hace fluir en el layout
.error-label {
    position: static;
    margin: 6px 0 0;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    color: var(--color-danger);
}

.field-note {
    margin: 4px 0 12px;
    font-size: 12px;
    color: #5f6b7a;
}

.group-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.group-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.5rem;
    border-radius: 999px;
    background-color: #e9ecef;
    font-size: 0.85em;
}

.group-chip-remove {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1em;
    line-height: 1;
    padding: 0;
}

.validation-summary {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff5f5;
}

.validation-summary__message {
    color: #dc3545;
    font-weight: 600;
    margin-bottom: 0.75rem;
}

.validation-summary__error {
    color: #dc3545;
    line-height: 1.5;
}

.validation-summary__error:not(:last-child) {
    margin-bottom: 0.25rem;
}

.password-note {
    margin: 0.35rem 0 1rem;
    font-size: 0.85rem;
    line-height: 1.5;
    color: var(--color-ghost);
}
</style>
